import { Link } from 'react-router-dom';
export const FaqSection = () => {
    return(
        <>
            <section aria-labelledby="have_any">
            <div className="container my-5">
                    <div className="d-flex justify-content-between align-items-center mb-4" id="view_all">
                        <h1  id="have_any">Have any <span style={{color:'#00675B'}}>questions?</span></h1>
                        <Link to="/collabwithgov/faq" className="btn btn-outline-dark view-all-btn" id="faq_all">View All</Link>
                    </div>
                    <div className="accordion" id="faqAccordion">
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingOne">
                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                1.	What is the "Collaborate with Government"?
                            </button>
                            </h2>
                            <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#faqAccordion">
                            <div className="accordion-body">
                            The "Collaborate with Government" initiative, hosted on OpenForge, allows students, developers, and coding enthusiasts to contribute to real-world government projects. 
                            </div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingTwo">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                2.	What is OpenForge, and how can I access it?
                            </button>
                            </h2>
                            <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#faqAccordion">
                            <div className="accordion-body">
                                OpenForge is the platform where government-related open-source projects are hosted for collaboration. Contributors can access the platform and participate in projects through the link:  <a href="https://openforge.gov.in/">https://openforge.gov.in/</a>
                            </div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingThree">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                3.	Who is eligible to contribute to "Collaborate with Government"?
                            </button>
                            </h2>
                            <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#faqAccordion">
                            <div className="accordion-body">
                            Any student, developer, or coding enthusiast with relevant skills can contribute. There are no strict educational or professional requirements. You just need a passion for coding and a desire to work on public projects. Each task will have its own technical skill requirements.
                            </div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingFour">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                4.	What kind of projects can I contribute to?
                            </button>
                            </h2>
                            <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#faqAccordion">
                            <div className="accordion-body">
                                You can contribute to various government projects related to digital services, public infrastructure, e-governance applications, and other technology-driven initiatives. These projects can involve development, bug fixing, testing, documentation, and design.
                            </div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingFive">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                5.	Do I need to be a professional developer to contribute?
                            </button>
                            </h2>
                            <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#faqAccordion">
                            <div className="accordion-body">
                            No, contributions are open to all levels of experience, from beginners to professionals. 
                            </div>
                            </div>
                        </div>
                        <div className="accordion-item">
                        <h2 className="accordion-header" id="headingSix">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                            6.	What types of tasks can I contribute to?
                            </button>
                        </h2>
                        <div id="collapseSix" className="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#faqAccordion">
                            <div className="accordion-body">
                            You can contribute to a variety of tasks, including:
                            <ol type="i">
                                <li>Code improvement suggestions</li>
                                <li>Test data preparation</li>
                                <li>Test Case preparation</li>
                                <li>Manual Testing</li>
                                <li>Automated testing - e.g. Selenium scripts</li>
                                <li>System Design Architecture suggestions</li>
                                <li>UX audit report submission</li>
                                <li>HTML web page design</li>
                                <li>Website development</li>
                                <li>Security Bug Testing</li>
                                <li>Performance Testing</li>
                                <li>New Feature development</li>
                                <li>Library/ Plugin Development</li>
                            </ol>
                            </div>
                        </div>
                       </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingSeven">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                                7.	Can I contribute to multiple tasks at once?
                            </button>
                            </h2>
                            <div id="collapseSeven" className="accordion-collapse collapse" aria-labelledby="headingSeven" data-bs-parent="#faqAccordion">
                            <div className="accordion-body">
                                Yes, you can contribute to multiple tasks. Just ensure that you create a new branch for each task, so the changes remain separate and do not interfere with one another.
                            </div>
                            </div>
                        </div>
                        <div className="accordion-item">
                        <h2 className="accordion-header" id="headingEight">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
                            8.	Can I contribute in areas other than coding?
                            </button>
                        </h2>
                        <div id="collapseEight" className="accordion-collapse collapse" aria-labelledby="headingEight" data-bs-parent="#faqAccordion">
                            <div className="accordion-body">
                            Yes! Contributions are not limited to coding. You can help improve documentation, suggest feature enhancements, report bugs, test applications, or even contribute to design and user experience improvements.
                            </div>
                        </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingNine">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
                                9.	How can task creators set up a task?
                            </button>
                            </h2>
                            <div id="collapseNine" className="accordion-collapse collapse" aria-labelledby="headingNine" data-bs-parent="#faqAccordion">
                            <div className="accordion-body">
                                Task creators should create a task in the "Collaborate with Government" tracker within the "OpenForge Community" project. The repository should be made accessible to all registered users on OpenForge.
                            </div>
                            </div>
                        </div>
                        <div className="accordion-item">
                        <h2 className="accordion-header" id="headingTen">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTen" aria-expanded="false" aria-controls="collapseTen">
                            10.	What are the steps for contributors to contribute code?
                            </button>
                        </h2>
                        <div id="collapseTen" className="accordion-collapse collapse" aria-labelledby="headingTen" data-bs-parent="#faqAccordion">
                            <div className="accordion-body">
                            <ol type="i">
                                <li>Clone the repository using git clone (repo URL).</li>
                                <li>Create a new branch using git checkout -b feature/your-branch-name.</li>
                                <li>Make and test the changes.</li>
                                <li>Commit the changes using git commit -m "Description of changes made".</li>
                                <li>Push the changes to the forked repository using git push origin feature/your-branch-name.</li>
                                <li>Submit a Pull Request (PR) on OpenForge.</li>
                            </ol>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className="" id="view_all_faq">
                    <Link to="/collabwithgov/faq" className="btn btn-outline-dark">View All</Link>
                    </div>
                </div>
                </section>
        </>
    )
}